"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHashRoute = exports.useBreakpoint = void 0;
var react_1 = require("react");
var layout_1 = require("./layout");
var browser_1 = require("./browser");
var config_1 = require("./config");
var defaultWindowDimensions = { width: layout_1.breakPointMap.lg, height: 600 };
function getWindowDimensions() {
    if (!(0, browser_1.isBrowser)())
        return defaultWindowDimensions;
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
// For compatibility with SSR, the first render in the client needs to be the
// same as the first render on the server. Afer that initial render, we can then
// update any values according to the user's actual browser dimensions
var useBreakpoint = function (bp) {
    var ssrCompatible = (0, react_1.useContext)(config_1.ChocolatesContext).ssr;
    var _a = (0, react_1.useState)(ssrCompatible ? defaultWindowDimensions : getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        ssrCompatible && handleResize(); // set after first-render for SSR compatibility
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [ssrCompatible]);
    var width = windowDimensions.width;
    return width <= (0, layout_1.breakPoint)(bp);
};
exports.useBreakpoint = useBreakpoint;
var useHashRoute = function (hash, vOffset) {
    var currentHash = (0, browser_1.isBrowser)() ? window.location.hash : '';
    var scrollTarget = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!(scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.current) || currentHash !== "#".concat(hash))
            return;
        window.scrollTo({
            top: scrollTarget.current.offsetTop + (vOffset || 0),
            behavior: 'smooth',
        });
    }, [scrollTarget, hash, currentHash]);
    return scrollTarget;
};
exports.useHashRoute = useHashRoute;
//# sourceMappingURL=hooks.js.map